export function convertFromAssetDb (cfg) {
  const pc = {
    source: {
      url: cfg.contentUrl,
      drmProtected: cfg.drmType !== 'NONE',
      type: clpp.utils.media.detectType(cfg.contentUrl)
    },
    preferredTextLanguage: cfg.preferredTextLanguage,
    preferredAudioLanguage: cfg.preferredAudioLanguage,
    startTime: cfg.startTime,
    autoplay: cfg.autoPlay,
    plugins: {},
    drm: {},
    metadata: Object.assign({}, cfg.metaData || {}),
    id: Number(cfg.id)
  };

  if (cfg.drmType === 'DRMTODAY') {
    pc.drm = {
      env: cfg.drmConfiguration.environment === 'PRODUCTION' ? 'DRMtoday' : ('DRMtoday_' + cfg.drmConfiguration.environment),
      customData: {
        merchant: cfg.drmConfiguration.merchant,
        userId: cfg.drmConfiguration.userId,
        sessionId: cfg.drmConfiguration.sessionId,
        assetId: cfg.drmConfiguration.assetId,
        variantId: cfg.drmConfiguration.variantId,
        authToken: cfg.drmConfiguration.authToken
      }
    };
  } else if (cfg.drmType === 'DRMTODAY_ONBOARD') {
    pc.drm = {
      env: 'DRMtodayOnboard',
      customData: {
        merchant: cfg.drmConfiguration.merchant,
        userId: cfg.drmConfiguration.userId,
        sessionId: cfg.drmConfiguration.sessionId,
        assetId: cfg.drmConfiguration.assetId,
        variantId: cfg.drmConfiguration.variantId,
        authToken: cfg.drmConfiguration.authToken,
        baseUrl: cfg.drmConfiguration.baseUrl
      }
    };
  } else if (cfg.drmType === 'CUSTOM') {
    const customData = {};
    if (cfg.drmConfiguration.WIDEVINE) {
      customData.widevineLicenseUrl =
          cfg.drmConfiguration.WIDEVINE.licensingUrl;
    }
    if (cfg.drmConfiguration.PLAYREADY) {
      customData.playReadyLicenseUrl =
          cfg.drmConfiguration.PLAYREADY.licensingUrl;
    }
    if (cfg.drmConfiguration.FAIRPLAY) {
      customData.fairPlayLicenseUrl =
          cfg.drmConfiguration.FAIRPLAY.licensingUrl;
      customData.fairPlayCertificateUrl =
          cfg.drmConfiguration.FAIRPLAY.certificateUrl;
    }
    pc.drm = {
      env: clpp.drm.HeaderDrm.NAME,
      customData
    };
  }

  if (cfg.drmSystem === 'WIDEVINE') {
    pc.drm.preferredDrmSystem = clpp.drm.KeySystem.WIDEVINE;
  } else if (cfg.drmSystem === 'PLAYREADY') {
    pc.drm.preferredDrmSystem = clpp.drm.KeySystem.PLAYREADY;
  } else if (cfg.drmSystem === 'FAIRPLAY') {
    pc.drm.preferredDrmSystem = clpp.drm.KeySystem.FAIRPLAY;
  }

  let type = 'Undefined';
  try {
    const source = cfg.contentUrl;
    let t = cfg.contentType;
    if (!t || t === 'AUTO') {
      if (typeof source === 'string') {
        t = clpp.utils.media.detectType(source);
      } else {
        t = clpp.utils.media.detectType(source.url);
      }
    }
    switch (t) {
      case 'DASH':
      case clpp.Type.DASH:
        type = 'MPEG-DASH';
        pc.source.type = clpp.Type.DASH;
        break;
      case 'SMOOTH':
      case clpp.Type.SMOOTH_STREAMING:
        type = 'Smooth Streaming';
        pc.source.type = clpp.Type.SMOOTH_STREAMING;
        break;
      case 'FILE':
      case clpp.Type.MP4:
        type = 'MP4';
        pc.source.type = clpp.Type.MP4;
        break;
      case 'HLS':
      case clpp.Type.HLS:
        type = 'HLS';
        pc.source.type = clpp.Type.HLS;
        break;
    }
  } catch (e) {
  }

  if (cfg.sideloadedTracks && cfg.sideloadedTracks.length) {
    cfg.sideloadedTracks.forEach(track => {
      if (track.trackType === 'THUMBNAIL') {
        pc.thumbnails = {
          url: track.url,
          // We get the mode out of assetdb. There we currently can get values:
          // WEBVTT, Grid, BIF. See
          // https://github.com/castlabs/assetdb/blob/77e883216cc19b9553e6648b7faf84d65fbea81b/assetdb/assets/models.py#L258C1-L261C1
          //
          // At this point, upper-casing the value will make this compatible
          // with the mode that we are supporting here
          mode: track.thumbType.toUpperCase()
        };
        if (typeof track.thumbDurationMs === 'number') {
          pc.thumbnails.duration = track.thumbDurationMs / 1000;
        }
        if (typeof track.thumbWidth === 'number' &&
            typeof track.thumbHeight === 'number') {
          pc.thumbnails.gridSize = `${track.thumbWidth}x${track.thumbHeight}`;
        }
      } else if (track.trackType === 'SUBTITLE') {
        if (!pc.remoteTextTracks) pc.remoteTextTracks = [];

        pc.remoteTextTracks.push({
          url: track.url,
          language: track.language,
          mimeType: track.mimeType,
          kind: track.kind || 'subtitle',
          label: track.label || 'N/A'
        });
      }
    });
  }

  if (cfg.lowLatencyMode) {
    pc.lowLatencyMode = cfg.lowLatencyMode;
  }

  if (cfg.adTagUrl) {
    pc.ima = {
      adTagUrl: cfg.adTagUrl
    };
  }

  if (cfg.suggestedPresentationDelay !== undefined &&
    cfg.suggestedPresentationDelay !== null) {
    try {
      const delay = Number(cfg.suggestedPresentationDelay);
      if (delay >= 0) {
        pc.suggestedPresentationDelay = delay;
      }
    } catch (e) {
      // ignore
    }
  }

  let img = cfg.metaData && cfg.metaData.posterUrl;
  if (!img) {
    img = cfg.metaData && cfg.metaData.thumbUrl;
  }
  return {
    id: Number(cfg.id),
    title: cfg.metaData && cfg.metaData.title,
    type: type,
    live: cfg.live,
    cfg: pc,
    updateUrl: cfg.configurationUrl,
    poster: {
      portrait: img,
      landscape: img
    }
  };
}
